import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button, { defaultClassNames } from './Button';

OutlineButton.propTypes = {
  icon: PropTypes.object,
  label: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default function OutlineButton(props) {
  const {
    children,
    label,
    onClick,
    disabled,
    icon
  } = props;

  return (
    <Button
      icon={icon && (
        <props.icon className={classNames(
          'h-5 w-5',
          'text-cs-gray-500'
        )} />
      )}
      label={label || children}
      onClick={onClick}
      disabled={disabled}
      overrideClassNames={{
        ...defaultClassNames,
        background:  'bg-transparent',
        border: '-m-px border border-cs-gray-500 border-opacity-30',
        textColor:  'text-cs-gray-500',
        hover:  'cursor-pointer hover:bg-cs-gray-50',
      }}
    />
  );
};
